/**
 * Faculty role helpers. CBC may be expressed as legacy `role: 'cbcfaculty'`, or
 * `role: 'faculty'` with `subtype: 'cbc'` (or legacy `facultyType: 'cbc'`).
 *
 * @param {{ role?: string, subtype?: string, facultyType?: string } | null | undefined} user
 */

export function isCbcFaculty(user) {
  if (!user) return false;
  if (user.role === 'cbcfaculty') return true;
  if (user.role === 'faculty' && user.subtype === 'cbc') return true;
  if (user.role === 'faculty' && user.facultyType === 'cbc') return true;
  return false;
}

export function isTeachingFacultyRole(user) {
  if (!user) return false;
  return user.role === 'faculty' || isCbcFaculty(user);
}

/** Course / lab / question / project teaching surfaces (faculty + cbcfaculty). */
export function canAccessTeaching(user) {
  return isTeachingFacultyRole(user);
}

/**
 * Mirrors the backend's `authorize("cbcfaculty","admin")` on
 * /api/coding-tracker/* EXACTLY — a strict match on `role`, with no subtype
 * fallback (AD-3).
 *
 * Deliberately stricter than {@link isCbcFaculty}: the backend middleware
 * compares `req.user.role` only, so a `role: 'faculty'` user with
 * `subtype: 'cbc'` passes isCbcFaculty() here but is still rejected with 403
 * server-side. Routing such a user into a platform-analytics screen produces a
 * page where every request fails.
 *
 * Reconciling that mismatch by widening the BACKEND to understand the modern
 * faculty/subtype model is tracked as its own story — it affects every
 * coding-analytics endpoint, not one report. Until then, the frontend matches
 * what the server actually enforces.
 */
export function canAccessPlatformAnalyticsApi(user) {
  if (!user) return false;
  return user.role === 'cbcfaculty' || user.role === 'admin';
}
